import { FC, PropsWithoutRef, Ref, forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { ForwardProps, NoChildrenProp } from '../../types';
import { defaultThemeProp } from '../../theme';

export interface AlertProps extends NoChildrenProp {
  /** Determines the color to render the Badge as. This color is derived from the Theme. */
  variant: 'urgent' | 'success';
}

export const StyledAlert = styled.div<AlertProps>(props => {
  const alerts = props.theme.components.badges.alert;
  const { background } = alerts[props.variant];
  const { 'border-color': borderColor } = alerts.base;
  return css`
    background: ${background};
    border: 0.0625rem solid ${borderColor};
    border-radius: 100%;
    display: inline-block;
    height: 0.625rem;
    width: 0.625rem;
  `;
});

StyledAlert.defaultProps = defaultThemeProp;

const Alert: FC<ForwardProps & AlertProps> = forwardRef(
  (props: PropsWithoutRef<AlertProps>, ref: Ref<HTMLDivElement>) => {
    const { variant, ...restProps } = props;
    return <StyledAlert {...restProps} variant={variant} ref={ref} />;
  }
);

export default Alert;
